var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

initGorgiasChatPromise.then(function () {
  GorgiasChat.on('widget:opened', function (data) {
    gtag('event', 'gorgias_chat_opened');
  });

  GorgiasChat.on('widget:closed', function (data) {
    gtag('event', 'gorgias_widget_closed');
  });

  GorgiasChat.on('message:received', function (data) {
    gtag('event', 'gorgias_message_received');
  });

  GorgiasChat.on('message:sent', function (data) {
    gtag('event', 'gorgias_message_sent');
  });
});